import {Component, OnInit} from '@angular/core';
import {RouteBuilder} from '@util/route-builder';
import {MarkantElementsModule} from '@markant/elements-angular';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [MarkantElementsModule, RouterLink],
})
export class FooterComponent implements OnInit {
  public copyrightYear: string;

  ngOnInit() {
    this.copyrightYear = new Date().getFullYear().toString();
  }

  get routes() {
    return {
      imprint: RouteBuilder.imprint().build(),
      termsOfUse: RouteBuilder.termsOfUse().build(),
      privacy: RouteBuilder.privacy().build(),
    };
  }
}
